import axiosInstance from "./axiosInstance";

export interface VehicleType {
  publicId: string;
  typeName: string;
  code: string;
  description: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface VehicleTypeSearchParams {
  TypeName?: string;
  Code?: string;
  IsActive?: boolean;
  PageNumber?: number;
  PageSize?: number;
}

export interface VehicleTypeSearchData {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  success: boolean;
  message: string;
  data: VehicleType[];
  errors: string[];
}

export interface VehicleTypeSearchResponse {
  success: boolean;
  message: string;
  data: VehicleTypeSearchData;
  errors: string[];
}

export interface CreateVehicleTypePayload {
  typeName: string;
  code: string;
  description: string;
  isActive: boolean;
}

export interface CreateVehicleTypeResponse {
  success: boolean;
  message: string;
  data: string;
  errors: string[];
}

export interface UpdateVehicleTypeResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: string[];
}

export interface GetVehicleTypeResponse {
  success: boolean;
  message: string;
  data: VehicleType;
  errors: string[];
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getVehicleTypes = async (): Promise<VehicleType[]> => {
  const res = await axiosInstance.get("/transport/vehicle-types", {
    headers: getAuthHeader(),
  });

  return res.data?.data ?? [];
};

export const searchVehicleTypes = async (
  params: VehicleTypeSearchParams = {}
): Promise<VehicleTypeSearchResponse> => {
  const res = await axiosInstance.get(
    "/transport/vehicle-types/search",
    {
      params,
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const createVehicleType = async (
  payload: CreateVehicleTypePayload
): Promise<CreateVehicleTypeResponse> => {
  const res = await axiosInstance.post(
    "/transport/vehicle-types",
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const updateVehicleType = async (
  publicId: string,
  payload: CreateVehicleTypePayload
): Promise<UpdateVehicleTypeResponse> => {
  const res = await axiosInstance.put(
    `/transport/vehicle-types/${publicId}`,
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getVehicleTypeById = async (
  publicId: string
): Promise<GetVehicleTypeResponse> => {
  const res = await axiosInstance.get(
    `/transport/vehicle-types/${publicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};